import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach token also via Authorization header (fallback if cookies blocked by browser)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("rf_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  /* iter-141 · structured FastAPI details (dict). Common shapes:
       { code, reason, scope, missing, hint, field, existing, proposed }
     Render a human sentence instead of the useless "[object Object]"
     fallback. Keeps every piece of context the backend sent. */
  if (detail && typeof detail === "object") {
    const parts = [];
    if (detail.reason) parts.push(detail.reason);
    else if (detail.code) parts.push(detail.code.replace(/_/g, " "));
    if (detail.scope) parts.push(`scope: ${detail.scope}`);
    if (Array.isArray(detail.missing) && detail.missing.length)
      parts.push(`missing: ${detail.missing.join(", ")}`);
    if (detail.field)    parts.push(`field: ${detail.field}`);
    if (detail.existing) parts.push(`existing: ${detail.existing}`);
    if (detail.proposed) parts.push(`proposed: ${detail.proposed}`);
    if (detail.pickup || detail.delivery)
      parts.push(`route: ${detail.pickup || "?"} → ${detail.delivery || "?"}`);
    if (detail.hint) parts.push(detail.hint);
    if (parts.length) return parts.join(" · ");
    try { return JSON.stringify(detail); } catch { return "Unspecified error"; }
  }
  return String(detail);
}
